/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { AuthSwitchOrganisationRequest, AuthSwitchOrganisationResponse } from '../types/AuthSwitchOrganisation'

/**
 * POST /auth/switch-organisation
 * @see backend/nexus/modules/Authentication/Http/Controllers/AuthController.php AuthController::switchOrganisation
 */
export async function authSwitchOrganisation(
	data: AuthSwitchOrganisationRequest,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<AuthSwitchOrganisationResponse>> {
	return axiosInstance.post('/auth/switch-organisation', data, config)
}
